import React from 'react';
import { useEffect, useState} from 'react';
import { store } from "../helpers/store";

// ***inputParam---we can pass anytype like [],{},"",we get result
//Note: when we pass [] or {} as input param,we need to pass "finalObjParam" as [] or {}- exception for one value in arry ["value"] no need to pass
//for one value of string "value" no need to pass second param  ******//

//This is the Custom Hook for getting parameterlookup values................
//throughtout the application we can use by importing...use as usual of buildin hooks format-const [value, setValue] = useState();

export function useTenantParams(inputParam, finalObjParam) {

    finalObjParam=finalObjParam || 0   //it create optional param in Javascript,means you need or need not to pass,in Typescript we use- x?

    const [param, setParam] = useState([] || {});

    let parameterlookup=store.getState().parametersWidgets.ParameterLookup

    let arrayCondition=Array.isArray(inputParam)&&(typeof (finalObjParam) === 'object'||Array.isArray(finalObjParam))  //any morethan two conditions we need to declare before using--- Coding Standards
    let objCondition=typeof (inputParam) === 'object'&&(typeof (finalObjParam) === 'object'||Array.isArray(finalObjParam))

    if (arrayCondition) {  //checking above declared arrayCondition condtion............
        for (let i = 0; i < inputParam.length; i++) {

            if (Array.isArray(finalObjParam)) { //Second praram as Array ot not checking...............

                finalObjParam.push(parameterlookup[inputParam[i]])

            } else if (typeof (finalObjParam) === 'object') { //Second param Object or not checking......

                finalObjParam[inputParam[i]] = parameterlookup[inputParam[i]]
            } 
            //****Below commented code-Need to do some what flexible--in future****//

            // else{
            //     if(inputParam.length>1){
            //         let finalObjParam=[]
            //         for (let i = 0; i < inputParam.length; i++) {
            //             finalObjParam.push(parameterlookup[inputParam[i]])
            //         }
            //     }else{
            //         finalObjParam=parameterlookup[inputParam]
            //     }
                
            // }

        }
    } else if (objCondition) {  //Checking Above declared objCondtion..........................

        let inputParamObject = Object.values(inputParam)

        for (let i = 0; i < inputParamObject.length; i++) {

            if (Array.isArray(finalObjParam)) {

                finalObjParam.push(parameterlookup[inputParamObject[i]])

            } else if (typeof (finalObjParam) === 'object') {

                finalObjParam[inputParamObject[i]] = parameterlookup[inputParamObject[i]]
            }

            //****Below commented code-Need to do some what flexible--in future**** 
            //*****if you are not passing secondParam- for array and object inputs- we need to get Array of results*** //
            // else{
            //     if(inputParamObject.length>1){
            //         for (let i = 0; i < inputParamObject.length; i++) {
            //             finalObjParam.push(parameterlookup[inputParamObject[i]])
            //         }
            //     }else{
            //         finalObjParam=parameterlookup[inputParamObject]
            //     }
            // }

        }
    }else{  

        finalObjParam=parameterlookup[inputParam] 
    }

    useEffect(() => {
        setParam(finalObjParam)
    }, finalObjParam)
    return [param]
}